import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { BankDetail } from '../bank-details/bankDetails';
import { VendorDetails } from 'src/app/models/vendor-details.model';

@Component({
  selector: 'app-vendor-details',
  templateUrl: './vendor-details.component.html',
  styleUrls: ['./vendor-details.component.scss'],
  providers: [MessageService, DatePipe]
})
export class VendorDetailsComponent implements OnInit {
  farmersDetailsForm: FormGroup;
  filteredVillage: any[];
  vendorType:string;
  isSubmitted = false;
  isLoading = false;
  villageList: { Code: number, Name: string }[];
  vendorID: string = '';
  genderType: string;
  selectedVillage: any;
  isEditable: any;
  todayDate: Date;
  farmerData: any;
  ipAddress: any = '000.000.000';
  isCasteCertificateMandatory: boolean = false;
  isCasteCertificteOptional: boolean = false;
  isAadharVerified: boolean = false;
  isPanVerified:boolean=false;
  showAadharVerDialog: boolean = false;
  aadharNumber: any;
  panNumber:any;
  emdNumber:any;
  bankName:any;
  aadharVerOTP: number;
  timer: number = 60;
  intervalId: any;
  bankAccount={bankName:'',ifscCode:''};

  public subscriptions: any = []
  public subjectSub: any;
  public openPPIDDialog: boolean = false;
  // public isMemberIdFound: boolean = false;
  // public PPPIdValue: any;
  public memberIdOTPValue: any;
  public pppIDData: any;
  public showPPPIdValidationBox: boolean = true;
  public isAadharNumberFound: boolean = false;
  public isPPPDataNotValidated: boolean = true;

  public fetchedFamilyData: any;
  public fetchedMemberId: any;
  public fetchedFamilyId: any;

  public showStatusMessage: boolean = false;
  public statusMessageText: any = 'nothingggg';
  public isErrorStatus: boolean = false;
  filteredBankList: any[];
  bankList: any;
  bnk: any;
  selectedVendorType: string;
  vendorTypes = [
    { label: 'Vendor', value: 'vendor' },
    { label: 'Supplier', value: 'supplier' }
  ];
  constructor(
    private productService: BankDetailService,
    private _fb: FormBuilder, 
    private _personalDetalSer: FarmersDetailsService, 
    private messageService: MessageService, 
    private datePipe: DatePipe,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService,
    private ipService: IpAddressService,
    private cryptoJsService: CryptoJsService,
    ) { }

  ngOnInit(): void {
    this.getBankNameList();
    this.getIP();
    this.todayDate = new Date();
    this.farmersDetailsForm = this._fb.group({
      vendorType:['',Validators.required],
      vendorsName: ['', Validators.required],
      address: ['', Validators.required],
      mobileNo: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      dob: [null, Validators.required],
      pincode: ['', Validators.required],
      emailId: ['', Validators.compose([Validators.required, Validators.email])],
      panNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('[A-Z]{5}[0-9]{4}[A-Z]{1}')]],
      village: [this.selectedVillage, Validators.required],
      accountNumber:['',Validators.required],
      bankName:['',Validators.required],
      ifscCode:['',Validators.required],
      gstNumber:['',[Validators.required, Validators.minLength(15), Validators.maxLength(15),Validators.pattern(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/)]],
      bIS_Certificate_path:['', Validators.required],
      exp_Certificate: ['', Validators.required],
      undertaking_path: ['', Validators.required],
      bank_Gurantee: ['', Validators.required],
      pAN_path: ['', Validators.required],
      demand_Draft_path: ['', Validators.required],
      aadhaar_No: ['', [Validators.required, Validators.minLength(12), Validators.maxLength(12)]],
      aadhaar_path: ['', Validators.required],
      gST_Certificate_path: ['', Validators.required],
      tradeMark_Doc: ['', Validators.required],
      registration_Certificate_path: ['', Validators.required],
      predispatch_Report_path: ['', Validators.required],
    });
    this.selectedVendorType = 'vendor';
    this.LoadFarmerDetails();
    this._personalDetalSer.getVillageMatserData().subscribe(res => {
      this.villageList = res;
      this.filteredVillage = [...this.villageList]

      if (this.farmerData?.Village_Code) {
        let village = this.villageList?.filter(val => val?.Code === this.farmerData?.Village_Code)[0]
        this.farmersFormControls.village.setValue(village?.Name);
        this.selectedVillage = village;
      }

      if (!window.localStorage.getItem("villageMaster")) {
        window.localStorage.setItem("villageMaster", JSON.stringify(res));
      }
    })
    // let phNo = sessionStorage.getItem('vendorPh');
    // this.farmersFormControls.mobileNo.setValue(phNo);
    // console.log(phNo);
    this.getCasteMaster()
  }
  get f() {
    return this.farmersDetailsForm.controls;
  }
  onVendorTypeChange(value: string) {
    this.selectedVendorType = value;
    if (value === 'vendor') {
      this.farmersDetailsForm.get('vendorsName').setValidators(Validators.required);
      this.farmersDetailsForm.get('supplierName').clearValidators();
    } else {
      this.farmersDetailsForm.get('supplierName').setValidators(Validators.required);
      this.farmersDetailsForm.get('vendorsName').clearValidators();
    }
    this.farmersDetailsForm.get('vendorsName').updateValueAndValidity();
    this.farmersDetailsForm.get('supplierName').updateValueAndValidity();
  }
  getCasteMaster() {
    this._personalDetalSer.getCasteMatserData().subscribe(res => {
    })
  }
  filterBank(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.bankList.length; i++) {
      const bank = this.bankList[i];
      if (bank.Bank_NAME.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(bank);
      }
    }

    this.filteredBankList = filtered;
  }
  getBankNameList() {
    this.productService.getAllBankNames().subscribe((data) => {
      if (data) {
        this.bankList = data;
        this.filteredBankList = data;
        // this.LoadFarmerDetails();
      }
    });
  }

  LoadFarmerDetails() {
    this.isLoading = true;
    let phNo = sessionStorage.getItem('vendorPh');
    this.farmersFormControls.mobileNo.setValue(phNo);
    let sub = this._personalDetalSer.getVendorDetails(phNo)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.isLoading = false;
          if (data && data.length > 0) {
            this.activityRecordService.activityRecord(phNo, 'vendor Details', '', new Date(), 'Success');
            let farmerData = data[0];
            if (farmerData) {
              this.farmerData = farmerData;
              this.isEditable = farmerData.IsEdit;
              this.farmersFormControls.vendorType.setValue(farmerData.Vendor_TypeId);
              this.farmersFormControls.vendorsName.setValue(farmerData.Vendor_Name);
              this.farmersFormControls.gstNumber.setValue(farmerData.gST_No);
              this.farmersFormControls.address.setValue(farmerData.Address);
              this.farmersFormControls.dob.setValue(farmerData.DOB ? new Date(farmerData.DOB) : null);
              this.farmersFormControls.pincode.setValue(farmerData.Pincode);
              this.farmersFormControls.emailId.setValue(farmerData.Email_ID);
              this.farmersFormControls.accountNumber.setValue(farmerData.Account_No);
              this.farmersFormControls.panNumber.setValue(farmerData.PAN_No);
              this.farmersFormControls.pAN_path.setValue(farmerData.pAN_path);
              this.farmersFormControls.bIS_Certificate_path.setValue(farmerData.bIS_Certificate_path);
              this.bnk = this.bankList?.find(val => val?.Bank_NAME == farmerData.Bank_Name);
              this.farmersFormControls.exp_Certificate.setValue(farmerData.exp_Certificate);
              this.farmersFormControls.undertaking_path.setValue(farmerData.undertaking_path);
              this.farmersFormControls.bank_Gurantee.setValue(farmerData.bank_Gurantee);
              this.farmersFormControls.demand_Draft_path.setValue(farmerData.demand_Draft_path);
              this.farmersFormControls.aadhaar_No.setValue(farmerData.aadhaar_No);
              this.farmersFormControls.aadhaar_path.setValue(farmerData.aadhaar_path);
              this.farmersFormControls.gST_Certificate_path.setValue(farmerData.gST_Certificate_path);
              this.farmersFormControls.tradeMark_Doc.setValue(farmerData.tradeMark_Doc);
              this.farmersFormControls.registration_Certificate_path.setValue(farmerData.registration_Certificate_path);
              this.farmersFormControls.predispatch_Report_path.setValue(farmerData.predispatch_Report_path);
              this.farmersFormControls.bankName.setValue(this.bnk?.bankName);
              this.bankAccount.bankName = this.bnk;
              this.farmersFormControls.ifscCode.setValue(farmerData.iFSC_Code);
              let village = this.villageList?.find(val => val?.Code === farmerData?.Village);
              this.farmersFormControls.village.setValue(village?.Name);
              this.selectedVillage = village;
            }
          }
        },
        error: (err) => {
          this.isLoading = false;
          this.activityRecordService.activityRecord(phNo, 'Vendor Details', '', new Date(), err);
          this.farmersFormControls.mobileNo.setValue(phNo);
        }
      });
    this.subscriptions.push(sub);
  }
  
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  get farmersFormControls() {
    return this.farmersDetailsForm.controls;
  }
  filterVillage(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.villageList.length; i++) {
      const village = this.villageList[i];
      if (village.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(village);
      }
    }
    this.filteredVillage = filtered;
  }

  onFarmersFormSubmit() {
    this.isSubmitted = true;
    if (this.farmersDetailsForm.valid) {
      this.isLoading = true;
      const data = this.mapDataToFarmersModel();
      let farmerData = JSON.parse(window.sessionStorage.getItem('vendorDetails'));
      if (farmerData) {
        this._insert(data)
      } else {
        this._insert(data)
      }
    }
  }

  // _update(data_) {
  //   let phNo = sessionStorage.getItem('vendorPh');
  //   this.loader.start();
  //   this._personalDetalSer.postVendersData(data_).pipe(first())
  //     .subscribe({
  //       next: (data) => {
  //         this.loader.close();
  //         this.isLoading = false;

  //         let reqBody = {
  //           MobileNo : this.farmersDetailsForm.controls.mobileNo.value
  //         }
      
  //         let reqBodyAfterEncypt = {
  //           "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
  //         }

  //         this._personalDetalSer.getFarmerDetails(reqBodyAfterEncypt)
  //           .pipe(first())
  //           .subscribe({
  //             next: (data) => {
  //               if (data) {
  //                 location.reload();
  //                 window.sessionStorage.setItem("vendorDetails", JSON.stringify(data.Table[0]));
  //               }
  //             }
  //           });
  //         if (data == "Farmer Details Updated Successfully!") {
  //           this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Farmer Details updated Successfully.' });
  //         } else {
  //           this.messageService.add({ severity: 'error', summary: 'Error Message', detail: data });
  //         }
  //         this.activityRecordService.activityRecord(phNo, 'Update Personal Details', '', new Date(), data, JSON.stringify(data_))
  //       },
  //       error: (err) => {
  //         this.loader.close();
  //         this.isLoading = false;
  //         this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Farmer Details not saved.' });
  //         this.activityRecordService.activityRecord(phNo, 'Update Personal Details', '', new Date(), err, JSON.stringify(data_));
  //       }
  //     });
  // }

  _insert(data_) {
    let phNo = sessionStorage.getItem('vendorPh');
    this.loader.start();
    this._personalDetalSer.postVendersData(data_).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.isLoading = false;
          this._personalDetalSer.getVendorDetails(this.farmersDetailsForm.controls.mobile.value)
            .pipe(first())
            .subscribe({
              next: (data) => {
                if (data) {
                  location.reload();
                  window.sessionStorage.setItem("VendorDetails", JSON.stringify(data.Table[0]));
                }
              }
            });
          if (data == "Vendor Details Inserted Successfully!") {
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Vendor Details inserted Successfully.' });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: data });
          }
          this.activityRecordService.activityRecord(phNo, 'Insert Personal Details', '', new Date(), data, JSON.stringify(data_))
        },
        error: (err) => {
          this.loader.close();
          this.isLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Vendors Details not saved.' });
          this.activityRecordService.activityRecord(phNo, 'Update Personal Details', '', new Date(), err, JSON.stringify(data_));
        }
      });
  }

  mapDataToFarmersModel(): VendorDetails {
    let farmerData = JSON.parse(window.sessionStorage.getItem('vendorDetails'));
    if (farmerData) {
      this.vendorID = farmerData.Vendor_ID;
    }
    let data: VendorDetails = {};
    let DOB: Date;
    let values = this.farmersDetailsForm.controls.dob.value.toString().split('-');
    if (values.length) {
      values.splice(1, 0, values.shift());
      DOB = values.join("-");
    }
    data.vendorId = this.vendorID;
    data.vendor_TypeId=this.farmersDetailsForm.value['vendorType'];
    data.vendor_Name = this.farmersDetailsForm.value['vendorsName'];
    data.address = this.farmersDetailsForm.value['address'];
    data.mobile = this.farmersDetailsForm.value['mobileNo'];
    data.dOI = DOB ? this.toISOLocal(new Date(DOB)).replace(/.\d+Z$/g, "") : this.toISOLocal(new Date((this.farmersDetailsForm.controls.dob.value))).replace(/.\d+Z$/g, "");
    data.pincode = this.farmersDetailsForm.value['pincode'];;
    data.email_ID = this.farmersDetailsForm.value['emailId'];
    data.pAN_No=this.farmersDetailsForm.value['panNumber'];
    data.pAN_path=this.farmersDetailsForm.value['pAN_path'];
    data.bIS_Certificate_path=this.farmersDetailsForm.value['bIS_Certificate_path'];
    data.exp_Certificate=this.farmersDetailsForm.value['exp_Certificate'];
    data.undertaking_path=this.farmersDetailsForm.value['undertaking_path'];
    data.bank_Gurantee=this.farmersDetailsForm.value['bank_Gurantee'];
    data.demand_Draft_path=this.farmersDetailsForm.value['demand_Draft_path'];
    data.taN_No=this.farmersDetailsForm.value['aadhaar_No'];
    data.taN_path=this.farmersDetailsForm.value['aadhaar_path'];
    data.gST_Certificate_path=this.farmersDetailsForm.value['gST_Certificate_path'];
    data.gST_No=this.farmersDetailsForm.value['gstNumber'];
    data.tradeMark_Doc=this.farmersDetailsForm.value['tradeMark_Doc'];
    data.registration_Certificate_path=this.farmersDetailsForm.value['registration_Certificate_path'];
    data.predispatch_Report_path=this.farmersDetailsForm.value['predispatch_Report_path'];
    data.village = this.farmersDetailsForm.value['village'].Code;
    data.iFSC_Code=this.farmersDetailsForm.value['ifscCode'];
    data.bank_Name=this.farmersDetailsForm.value['bankName'].Bank_NAME;
    data.account_No=this.farmersDetailsForm.value['accountNumber'];
    return data;
  }

  onFarmerPhotoUpload(event) {
    this.messageService.add({ severity: 'info', summary: 'Success', detail: 'File Uploaded with Auto Mode' });
  }
  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    let phNo = sessionStorage.getItem('vendorPh');
    this._personalDetalSer.uploadFile(data, phNo, formcontrol).subscribe((resp: any) => {
      if (resp.statusCode == 200) {
        this.farmersDetailsForm.patchValue({ [formcontrol]: resp.data });
      }
    })
    uploadElement.clear();

  }

  getVillageData() {
    this.loader.start();
    this._personalDetalSer.getVillageMatserData().subscribe(res => {
      this.loader.close();
      this.villageList = res;
      this.filteredVillage = [...this.villageList]
      if (!window.localStorage.getItem("villageMaster")) {
        window.localStorage.setItem("villageMaster", JSON.stringify(res));
      }
    })
  }

  toISOLocal(d) {
    var z = n => ('0' + n).slice(-2);
    var off = d.getTimezoneOffset();
    off = Math.abs(off);
    return d.getFullYear() + '-'
      + z(d.getMonth() + 1) + '-' +
      z(d.getDate());
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }

  // verifyAadhar(){
  //   this.validateAadharNumber(this.aadharNumber);
  // }

  // validateAadharNumber(aadharNumber){
  //   let phNo = sessionStorage.getItem('vendorPh');
  //   this.loader.start();
  //   this._personalDetalSer.validateAadhar(aadharNumber).pipe(first())
  //     .subscribe({
  //       next: (data) => {
  //         this.loader.close();
  //         if (data == "OTP sent") {
  //           this.showAadharVerDialog = true;
  //           this.startTimer();
  //           this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'OTP Sent Successfully.' });
  //         } else {
  //           this.messageService.add({ severity: 'info', summary: 'Info Message', detail: data });
  //         }
  //         this.activityRecordService.activityRecord(phNo, 'Validate Aadhar Number', '', new Date(), data, aadharNumber);
  //       },
  //       error: (err) => {
  //         this.loader.close();
  //         this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
  //         this.activityRecordService.activityRecord(phNo, 'Validate Aadhar Number(error)', '', new Date(), err, aadharNumber);
  //       }
  //     });
  // }

  hideDialog(){
    this.showAadharVerDialog = false;
    this.aadharVerOTP = null;
  }

  submitOTP(){
    this.validateOTP(this.aadharNumber, this.aadharVerOTP)
  }

  validateOTP(aadharNumber, otp){
    let phNo = sessionStorage.getItem('vendorPh');
    this.loader.start();
    this._personalDetalSer.validateOTP(aadharNumber, otp, '').pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data.startsWith('s') || data.startsWith('S')) {
            this.isAadharVerified = true;
            this.hideDialog();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Aadhar Validated Successfully.' });
          } else {
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: data });
          }
          this.activityRecordService.activityRecord(phNo, 'Validate OTP For Aadhar Verification', '', new Date(), data, aadharNumber);
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
          this.activityRecordService.activityRecord(phNo, 'Validate OTP For Aadhar Verification', '', new Date(), err, aadharNumber);
        }
      });
  }


  startTimer(): void {
    this.intervalId = setInterval(() => {
      if (this.timer > 0) {
        this.timer--;
      } else {
        clearInterval(this.intervalId);
      }
    }, 1000);
  }

  resendOTP(): void {
    this.timer = 60;
    this.startTimer();
  }

  editAadharNumber(){
    this.hideDialog();
  }

  findMemberIdFromUID(){
    this.showStatusMessage = true;
    this.getMemberIdFromUID();
  }

  clearPPPIdData(){
    this.memberIdOTPValue = null;
    this.showPPPIdValidationBox = true;
    this.fetchedFamilyData = null;
    this.statusMessageText = null;
    this.showStatusMessage = false;
  }

  hidePPIDDialog(){
    this.openPPIDDialog = false;
    this.clearPPPIdData();
  }

  getMemberIdFromUID(){
    let phNo = sessionStorage.getItem('vendorPh');
    this.loader.start();  
    this._personalDetalSer.getFamilyIdByUID('', '200411089222').pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data.message == "Record Match") {
            this.isErrorStatus = false;
            this.statusMessageText = 'PPP Id fetched from Aadhar Number. Verifying it...'
            this.fetchedFamilyData = data.result[0];
            this.fetchedMemberId = this.fetchedFamilyData.memberid;
            this.fetchedFamilyId = this.fetchedFamilyData.familyid;
            this.verifyPPPId(this.vendorID, this.fetchedFamilyId);
            this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Family Id Fetched' });
          } else {
            this.isErrorStatus = true;
            this.statusMessageText = `${data}. Please try again.`
            this.messageService.add({ severity: 'info', summary: data.message, detail: data });
          }
        },
        error: (err) => {
          this.isErrorStatus = true;
          this.statusMessageText = `${err}. Please try again.`
          this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
        }
      });
  }

  verifyPPPId(vendorId, familyId){
    this.loader.start();
    this._personalDetalSer.getVerifyPPPID(vendorId, familyId).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          data = data[0].Column1;
          if(data == "Record not matched"){
            this.openPPIDDialog = true;
            this.isErrorStatus = false;
            this.statusMessageText = data;
            this.sendOTPforMEMID();
            this.messageService.add({ severity: 'success', summary: 'Success', detail: data });
          }else{
            this.isErrorStatus = true;
            this.statusMessageText = `${data}. Please try again.`
            this.messageService.add({ severity: 'error', summary: 'Error', detail: data });
          }
        },
        error: (err) => {
          this.loader.close();
          this.isErrorStatus = true;
          this.statusMessageText = `${err}. Please try again.`
          this.openPPIDDialog = false;
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
        }
      });
  }

  sendOTPforMEMID (){
    this.loader.start();
    this._personalDetalSer.OTPRequestforMEMID(this.fetchedMemberId).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if(data == "OTP Sent to registered mobile No."){
            this.isErrorStatus = false;
            this.statusMessageText = data;
            this.messageService.add({ severity: 'success', summary: 'OTP Sent', detail: data });
          }else{
            this.openPPIDDialog = false;
            this.isErrorStatus = true;
            this.statusMessageText = `${data}. Please try again.`
            this.messageService.add({ severity: 'error', summary: 'OTP Not Sent', detail: data });
          } 
        },
        error: (err) => {
          this.loader.close();
          this.openPPIDDialog = false;
          this.isErrorStatus = true;
          this.statusMessageText = `${err}. Please try again.`
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
        }
      });
  }

  onClickBack(){
    this.showPPPIdValidationBox = true;
    this.clearPPPIdData();
  }

  onSubmitMemIdOTP(){
    this.loader.start();
    this._personalDetalSer.verifyOTPRequestForMID(this.fetchedMemberId, null, this.memberIdOTPValue).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if(data.message == "Record Match"){
            this.isErrorStatus = false;
            this.statusMessageText = data.message;
            this.pppIDData = data.result;
            this.isPPPDataNotValidated = false;
            this.openPPIDDialog = false;
            this.messageService.add({ severity: 'success', summary: data.status , detail: data.message });
          }else{
            this.isErrorStatus = true;
            this.statusMessageText = data.message;
            this.messageService.add({ severity: 'error', summary: data.status , detail: data.message });
          }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
        }
      });
  }
  public loading: boolean = false;
  farmerId: any;
  bankAccountList: VendorDetails[] = [];
  getBankList() {
    this.loading = true;
   this.productService
     .getBankDetails(this.farmerId)
     .pipe(first())
     .subscribe({
       next: (data) => {
         this.loading = false;
         let d = data ?? [];
         this.bankAccountList = d.map((res) => {
           return {
             accountHolderName: res.Account_Holder_Name,
             accountNumber: res.Account_NO,
             bankName: this.bankList
               .filter((d) => d.BANK_ID === res.Bank_ID)
               .map((d) => d.Bank_NAME)[0],
             ifscCode: res.IFSC_code,
             image: res.Passbook_Copy_Upload,
             ...res,
           };
         });
       },
       error: () => {
         this.loading = false;
         this.messageService.add({
           severity: 'error',
           summary: 'Error Message',
           detail: 'Data error! Farmer Bank Details not loaded.',
         });
       },
      });
    }
    
}

